import { useFormik } from "formik";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { userOption, userResult} from '../../models/orders/order-list-model';
import { useState, useEffect, useRef } from "react";
import orderServices from '../../services/orders/orderservice';
import { InputNumber } from "primereact/inputnumber";
import ComplaintService from "../../services/complaint/ComplaintService";
import { Toast, ToastMessage } from "primereact/toast";
import { classNames } from "primereact/utils";
import { complaintmodel1,InvoiceNoDetails, ProductDetails, userProduct, CompCategory, userCompCategory
  , CompType, userCompType, CompStatus, userCompStatus
  } from "../../models/complaints/complaint-model";
import { RadioButton } from "primereact/radiobutton";
import { TabView, TabPanel } from 'primereact/tabview';
import { CascadeSelect, CascadeSelectChangeEvent } from "primereact/cascadeselect";
import { useNavigate } from 'react-router-dom';

interface YearOption {
  name: string;
  code: string;
  months: MonthOption[];
}

interface MonthOption {
  name: string;
  code: string;
  invoices: InvoiceOption[];
}

interface InvoiceOption {
  name: number | string;
  code: number | string;
  invoice: InvoiceNoDetails;
}


interface EditComplaintProps {
  isUpdate: boolean;
  handleOnSuccess: () => void;
  updateComplaintInfo: complaintmodel1 | undefined | null;
  AddedData:any
}

const InternalComplaint: React.FC<EditComplaintProps> = ({ isUpdate, handleOnSuccess, updateComplaintInfo }) => {
  const [categories, setCategories] = useState<any>("");
  const blankUserDetail: userOption[] = [{ userID: 0, name: '', primaryContactNbr: ''}];
  const [orderUsers, setOrderUsers] = useState<userOption[]>(blankUserDetail);
  const [statusOptions, setStatusOptions] = useState([]);
  const [orderUser, setOrderUser] = useState<userResult[]>([]);
  const [selectedUser, setSelectedUser] = useState<any>();
  const [orderInvoices, setOrderInvoices] = useState<InvoiceNoDetails[]>([]);
  const [selectedInvoiceNo, setSelectedInvoiceNo] = useState<any>();
  const [imageFile, setImageFile] = useState<any>(null);
  const [videoFile, setVideoFile] = useState<any>(null);
  const blankProductDetails: ProductDetails[] = [{ productId: 0, name: '', quantity: 0, orderInvoiceDetailID: 0 }];
  const [products, setProducts] = useState<ProductDetails[]>(blankProductDetails);
  const [orderProduct, setOrderProduct] = useState<userProduct[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<any>();
  const blankCompCategoryDetails: CompCategory[] = [{ complaintCategoryId: 0, complaintName: '' }];
  const [compCat, setcompCat] = useState<CompCategory[]>(blankCompCategoryDetails);
  const [CompCategorys, setCompCategorys] = useState<userCompCategory[]>([]);
  const [selectedCompCategory, setSelectedCompCategory] = useState<any>();
  const blankCompTypeDetails: CompType[] = [{ complaintTypeId: 0, complaintName: '' }];
  const [compTyp, setcompTyp] = useState<CompType[]>(blankCompTypeDetails);
  const [CompTyps, setCompTyps] = useState<userCompType[]>([]);
  const [selectedCompTyp, setSelectedCompType] = useState<any>();
  const blankCompStatusDetails: CompStatus[] = [{ statusId: 0, name: '' }];
  const [compStatus, setcompStatus] = useState<CompStatus[]>(blankCompStatusDetails);
  const [CompStatuss, setCompStatuss] = useState<userCompStatus[]>([]);
  const toast = useRef<Toast>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const blankAdminDetail: userOption[] = [{ userID: 0, name: 'Not Found', primaryContactNbr: '' }];
  const [adminUsers, setAdminUsers] = useState<userOption[]>(blankAdminDetail);
  const [adminUser, setAdminUser] = useState<userResult[]>([]);
  const [selectedAdmin, setSelectedAdmin] = useState<any>();
  const [loginUser,setLoginUser] = useState<any>();
  const [hoveredField, setHoveredField] = useState<string | null>(null);
  const [tableData, setTableData] = useState<complaintmodel1[]>([]);
  const [complaintType, setComplaintType] = useState<string>('');
  const [activeTab, setActiveTab] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [complaintMode, setComplaintMode] = useState<'internal' | 'external' | null>(null);
  const [invoiceHierarchy, setInvoiceHierarchy] = useState<YearOption[]>([]);
  const navigate = useNavigate();



const AddedData = (newData: complaintmodel1) => {
  setTableData(prev => [newData, ...prev]); 
};

const formatDate = (dateInput: string | number | Date): string => {
  const date = new Date(dateInput);
  
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

  useEffect(() => {
    if (orderUsers && orderUsers.length > 0) {
      setOrderUser(orderUsers.map((user) => {
        return {
          userID: user.userID,
          detail: user.userID !== 0 ? `${user.name} , ${user.primaryContactNbr}` : "",
        };
      }));
    }
    if (adminUsers && adminUsers.length > 0) {
      setAdminUser(adminUsers.map((admin) => {
        return {
          userID: admin.userID,
          name: admin.name,
          detail: admin.userID !== 0 ? `${admin.name}, ${admin.primaryContactNbr}` : "",
        };
      }));
    }
    if (products && products.length > 0) {
      setOrderProduct(products.map((product) => {
        return {
          productId: product.productId,
          productName: product.name,
          orderInvoiceDetailID: product.orderInvoiceDetailID,
          detail: product.productId !== 0 ? `${product.name}, Quantity - ${product.quantity}` : "",
        };
      }));
    }
    if (compCat && compCat.length > 0) {
      setCompCategorys(compCat.map((compCategory) => {
        return {
          complaintCategoryId: compCategory.complaintCategoryId,
          complaintName: compCategory.complaintName,
        };
      }));
    }
    if (compTyp && compTyp.length > 0) {
      setCompTyps(compTyp.map((CompType) => {
        return {
          complaintTypeId: CompType.complaintTypeId,
          complaintName: CompType.complaintName,
        };
      }));
    }
    if (compStatus && compStatus.length > 0) {
      setCompStatuss(compStatus.map((CompStatus) => {
        return {
          statusId: CompStatus.statusId,
          name: CompStatus.name,
        };
      }));
    }
  }, [orderUsers, products, compCat, compTyp, compStatus, adminUsers]);

  const formatLocalDate = (date: Date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  useEffect(() => {
    fetchComplaintCategory();
    fetchComplaintType();
    fetchComplaintStatus();
    var LoginDetails = localStorage.getItem('user')
    if(LoginDetails != null)
    {
      setLoginUser(JSON.parse(LoginDetails));
    }
  }, []);

  const handlePhoneDropdownChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const selectedUser = e.value;
    setSelectedUser(selectedUser);
    setFieldValue("userId", e.value);
    const userDetails = orderUsers.filter(x => x.userID === e.value);
    setFieldValue("userName",userDetails[0].name);
    setFieldValue("userPhoneNo",userDetails[0].primaryContactNbr)
    const invoices = await ComplaintService.getUserInvoicesAll(selectedUser);
    setOrderInvoices(invoices);

     const invoiceHierarchyData = structureInvoiceData(invoices);
    setInvoiceHierarchy(invoiceHierarchyData);
  };

const structureInvoiceData = (invoices: InvoiceNoDetails[]): YearOption[] => {
  const yearsMap = new Map<string, Map<string, InvoiceNoDetails[]>>();

  invoices.forEach(invoice => {
    const invoiceDate = new Date(invoice.invoiceDate);
    const year = invoiceDate.getFullYear().toString();
    const month = invoiceDate.toLocaleString('default', { month: 'long' });
    
    if (!yearsMap.has(year)) {
      yearsMap.set(year, new Map<string, InvoiceNoDetails[]>());
    }
    
    const monthsMap = yearsMap.get(year)!;
    if (!monthsMap.has(month)) {
      monthsMap.set(month, []);
    }
    
    monthsMap.get(month)!.push(invoice);
  });

  const result: YearOption[] = [];
  
  yearsMap.forEach((monthsMap, year) => {
    const months: MonthOption[] = [];
    
    monthsMap.forEach((monthInvoices, monthName) => {
      const invoices: InvoiceOption[] = monthInvoices.map(invoice => ({
        name: `${invoice.invoiceNo} - ${formatDate(invoice.invoiceDate)}`, 
        code: invoice.invoiceNo,
        invoice: invoice       
      }));
      
      months.push({
        name: monthName,
        code: monthName,
        invoices: invoices
      });
    });
    
    result.push({
      name: year,
      code: year,
      months: months
    });
  });

  return result;
};

  const handlePhoneDropdownFilter = (e: DropdownFilterEvent) => {
    if (e.filter.length > 2) {
      orderServices.getOrderUsers(e.filter).then((response: userOption[]) => {
        if (response.length > 0) {
          setOrderUsers(response);
        }
      });
    }
  };

  const handleAdminDropdownChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const selectedAdmin = e.value;
    const actionedByName = adminUsers.filter(x => x.userID === e.value)[0].name;
    setSelectedAdmin(selectedAdmin);
    setFieldValue("actionedBy", e.value);
    setFieldValue("actionedByName", actionedByName);
  };

  const handleAdminDropdownFilter = (e: DropdownFilterEvent) => {
    if (e.filter.length > 2) {
      ComplaintService.getAdminUsers(e.filter).then((response: userOption[]) => {
        if (response.length > 0) {
          setAdminUsers(response);
        }
      });
    }
  };

  const handleInvoiceChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const selectedInvoice = e.value;
    const invoiceNo = selectedInvoice.invoiceNo;
    const orderInvoiceID = selectedInvoice.orderInvoiceID;
    const products = await ComplaintService.getInvoicedproducts(orderInvoiceID);
    setFieldValue("purchaseInvoiceNumber", selectedInvoice);
    setProducts(products);
    setSelectedInvoiceNo(invoiceNo);
  };

  const handleImageUpload = (e: any) => {
    setImageFile(e.files[0]);
  };

  const handleVideoUpload = (e: any) => {
    setVideoFile(e.files[0]);
  };

  const handleImageCancel = () => {
    setImageFile(null);
  };

  const handleVideoCancel = () => {
    setVideoFile(null);
  };

  const handleProductChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const category = await ComplaintService.getProductCategory(e.value);
    const productName = orderProduct.filter(x => x.productId === e.value)[0].productName;
    setFieldValue("productId", e.value);
    setFieldValue("productName", productName);
    setFieldValue("productCategoryName", category[0].categoryName);
    setCategories(category);
    setSelectedProducts(e.value);
  };

    const severityItems = [
    { name: "High", severityID: 1 },
    { name: "Medium", severityID: 2 },
    { name: "Low", severityID: 3}
  ];

  const handleSeverityChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    setFieldValue("severity", e.value);
  };

  const handleCompCategoryChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const selectedCompCategory = e.value;
    const complaintCategoryName = CompCategorys.filter(x => x.complaintCategoryId === e.value)[0].complaintName;
    setSelectedCompCategory(selectedCompCategory);
    setFieldValue("complaintCategory", e.value);
    setFieldValue("complaintCategoryName", complaintCategoryName);
  };

  const fetchComplaintCategory = async () => {
    const CompCat = await ComplaintService.getComplaintCategory();
    setcompCat(CompCat);
  };

  const handleCompTypeChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const selectedCompType = e.value;
    const complaintName = CompTyps.filter(x => x.complaintTypeId === e.value)[0].complaintName;
    setSelectedCompType(selectedCompType);
    setFieldValue("complaintType", e.value);
    setFieldValue("complaintTypeName", complaintName);
  };

  const fetchComplaintType = async () => {
    const CompTyp = await ComplaintService.getComplaintType();
    setcompTyp(CompTyp);
  };

  const handleComStatusChange = async (e: DropdownChangeEvent, setFieldValue: any) => {
    const stName = compStatus.filter(x => x.statusId === e.value)[0].name;
    setFieldValue("status", e.value);
    setFieldValue("stName", stName);
  };

  const fetchComplaintStatus = async () => {
    const CompStatus = await ComplaintService.getComplaintStatus();
    setcompStatus(CompStatus);
  };
  const fetchTableData = async (page: number, size: number) => {
  const data = await ComplaintService.getAllComplaints(size, page); 
  setTableData(data);
};

  const showMessage = (label: string, message: string, severity: ToastMessage['severity']) => {
    toast.current?.show({ severity: severity, summary: label, detail: message, life: 3000 });
  };

  const generateComplaintNumber = () => {
    const timestamp = new Date().getTime();
    return `CMP${timestamp}`;
  };

  const handleComplaintTypeSelect = (type: 'internal' | 'external') => {
    setComplaintMode(type);
    setShowForm(true);
  };

  const formik = useFormik({
    initialValues: {
      complaintNumber: generateComplaintNumber(),
      complaintDate: "",
      userId: "",
      userName: "",
      userPhoneNo: null,
      //purchaseInvoiceNumber: null,
      purchaseInvoiceNumber: null as InvoiceNoDetails | null,
      productId: "",
      productName: "",
      packingType: "",
      dateCode: "",
      complaint: "",
      image: null,
      video: null,
      category: categories,
      complaintCategory: "",
      complaintCategoryName: "",
      productCategoryName: "",
      complaintType: "",
      complaintTypeName: "",
      remarks: "",
      correctiveAction: "",
      preventiveAction: "",
      customerSupportAction: "",
      actionedBy: "",
      actionedByName: "",
      status: "",
      stName: "",
      actionDate: "",
      satisfactionLevel: "",
      severity: null,
      copqInRs: null,
    },
    validationSchema: Yup.object({
      userId: Yup.string().required("Please select user info"),
      //purchaseInvoiceNumber: Yup.object().required("Please select invoice number"),
  purchaseInvoiceNumber: Yup.object().shape({
    orderInvoiceID: Yup.number().required(),
    invoiceNo: Yup.string().required(),
    invoiceDate: Yup.string().required()
  }).required("Please select an invoice"),
      productId: Yup.string().required("Please select product name"),
      complaintCategory: Yup.string().required("Please select complaint category"),
      complaintType: Yup.string().required("Please select complaint type"),
      actionedBy: Yup.string().required("Please select actioned by"),
      status: Yup.string().required("Please select status"),
    }),
    onSubmit: async (data: any) => {
  if (isSubmitted) return;
  setIsSubmitted(true);

  const complaint = {
    complaintNumber: data.complaintNumber,
    customerId: data.userId,
    purchaseInvoiceId: data.purchaseInvoiceNumber?.orderInvoiceID,
    productId: data.productId,
    packingType: data.packingType,
    dateCodeBatchCode: data.dateCode,
    description: data.complaint,
    image: data.image,
    video: data.video,
    complaintCategoryId: data.complaintCategory,
    complaintTypeId: data.complaintType,
    remarks: data.remarks,
    correctiveAction: data.correctiveAction,
    preventiveAction: data.preventiveAction,
    customerSupportAction: data.customerSupportAction,
    actionedBy: data.actionedBy,
    statusId: data.status,
    actionDate: data.actionDate === "" ? null : data.actionDate,
    complainantSatisfaction: data.satisfactionLevel,
    severity: data.severity,
    copqInRs: data.copqInRs,
    productCategoryId: categories.length > 0 ? categories[0].categoryID : null,
    createdBy: loginUser?.userID || 0,
    createdByName: loginUser?.name || '',
    isInternalComplaint: complaintMode === 'internal'
  };

  try {
    const response = await ComplaintService.saveNewComplaint(complaint);  
    if (response && response.isSuccess) {
        navigate('/View-All-Complaints-datatable');
      navigate('/View-all-Complaints');
      handleOnSuccess();
      showMessage('Success', `${complaintMode === 'internal' ? 'Internal' : 'External'} complaint created successfully`, 'success');
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      formik.resetForm();

    } else {
      const errorMessage = response?.message || 'Request failed but no error message provided';
      showMessage('Error', errorMessage, 'error');
    }
  } catch (error) {
    console.error("Error during complaint submission", error);
    showMessage('Error', 'Failed to create complaint', 'error');
  } finally {
    setIsSubmitted(false);
  }
},
  });

  const fieldHoverStyle = (fieldName: string) => ({
    border: hoveredField === fieldName ? '2px solid #6366F1' : '1px solid #ced4da',
    borderRadius: '6px',
    transition: 'border 0.2s ease-in-out',
    width: '100%',
    minHeight: '40px'
  });
  const formContainerStyle = {
  width: '60%',
  margin: '1.5% auto', 
  padding: '20px',
  //backgroundColor: 'black',
  border : '2px solid gray',
  borderRadius: '6px'
};

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <div style={formContainerStyle}>
      <div className="col-12 flex align-items-stretch flex-wrap gap-1">
        <div className="flex flex-1 bg-white align-items-center justify-content-center">
          <div className="w-full">
            <h5 className='border-round mb-3 order-top-color p-2 panel-header-text text-center'>
              Register Internal Complaints
            </h5>
              <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid">
                  <div className="grid">
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="userMobile" className="required-label" style={{ fontWeight: 'bold' }}>
                          User Name/Mobile Number <span style={{ color: "red", fontSize: "24px" }}>*</span>
                        </label>
                        <div onMouseEnter={() => setHoveredField('userId')} onMouseLeave={() => setHoveredField(null)} style={fieldHoverStyle('userId')}>
                          <Dropdown
                            placeholder="Select User"
                            id="userMobile"
                            name="userMobile"
                            options={orderUser}
                            optionLabel="detail"
                            optionValue="userID"
                            value={formik.values.userId}
                            onChange={(e: DropdownChangeEvent) => handlePhoneDropdownChange(e, formik.setFieldValue)}
                            onFilter={handlePhoneDropdownFilter}
                            filter
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                        {formik.errors.userId && formik.touched.userId && ( <small className="p-error">{formik.errors.userId as string}</small>)}
                      </div>
                    </div>
                  <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="purchaseInvoiceNumber" className="required-label" style={{ fontWeight: 'bold' }}>
                          Purchase Invoice Number <span style={{ color: "red", fontSize: "24px" }}>*</span>
                        </label>
                        <div onMouseEnter={() => setHoveredField('purchaseInvoiceNumber')} onMouseLeave={() => setHoveredField(null)} style={fieldHoverStyle('purchaseInvoiceNumber')}>
                        <CascadeSelect
                          id="purchaseInvoiceNumber"
                          name="purchaseInvoiceNumber"
                          value={formik.values.purchaseInvoiceNumber ? 
                            `${formik.values.purchaseInvoiceNumber.invoiceNo} - ${formatDate(formik.values.purchaseInvoiceNumber.invoiceDate)}` : 
                            ''}
                          options={invoiceHierarchy}
                          optionLabel="name"
                          optionGroupLabel="name"
                          optionGroupChildren={['months', 'invoices']}
                          style={{ width: '100%' }}
                          placeholder="Select invoice number"
                          onChange={(e: CascadeSelectChangeEvent) => {
                            if (e.value && e.value.invoice) {
                              formik.setFieldValue("purchaseInvoiceNumber", e.value.invoice);
                              handleInvoiceChange({ value: e.value.invoice } as DropdownChangeEvent, formik.setFieldValue);
                            } else {
                              formik.setFieldValue("purchaseInvoiceNumber", null);
                            }
                          }}
                        />
                        </div>
                        {formik.errors.purchaseInvoiceNumber && formik.touched.purchaseInvoiceNumber && (
                          <small className="p-error">{formik.errors.purchaseInvoiceNumber as string}</small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="grid">
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="productName" style={{ fontWeight: 'bold' }}>Product Name<span style={{ color: "red", fontSize: "24px" }}>*</span></label>
                        <div onMouseEnter={() => setHoveredField('productId')} onMouseLeave={() => setHoveredField(null)} style={fieldHoverStyle('productId')}>
                          <Dropdown
                            placeholder="Select Product Name"
                            id="productName"
                            name="productName"
                            options={orderProduct}
                            optionLabel="detail"
                            optionValue="productId"
                            value={formik.values.productId}
                            onChange={(e: DropdownChangeEvent) => handleProductChange(e, formik.setFieldValue)}
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }} />  
                        </div>                  
                        {formik.errors.productId && formik.touched.productId && (<small className="p-error">{formik.errors.productId as string}</small>)}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="category" style={{ fontWeight: 'bold' }}>Category</label>
                        <div onMouseEnter={() => setHoveredField('category')} onMouseLeave={() => setHoveredField(null)} style={fieldHoverStyle('category')}>
                          <InputText
                            id="category"
                            name="category"
                            value={categories.length > 0 ? categories[0].categoryName : ''}
                            disabled={true}
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid">
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="complaintCategory" style={{ fontWeight: 'bold' }}>Complaint Category <span style={{ color: "red", fontSize: "24px" }}>*</span></label>
                        <div onMouseEnter={() => setHoveredField('complaintCategory')} onMouseLeave={() => setHoveredField(null)} style={fieldHoverStyle('complaintCategory')}>
                          <Dropdown
                            placeholder="Select Complaint Category"
                            name="complaintCategory"
                            id="complaintCategory"
                            options={CompCategorys}
                            optionLabel="complaintName"
                            optionValue="complaintCategoryId"
                            value={formik.values.complaintCategory}
                            onChange={(e: DropdownChangeEvent) => handleCompCategoryChange(e, formik.setFieldValue)}
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                        {formik.errors.complaintCategory && formik.touched.complaintCategory && ( <small className="p-error">{formik.errors.complaintCategory as string}</small>)}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="packingType" style={{ fontWeight: 'bold' }}>Packing Type</label>
                        <div onMouseEnter={() => setHoveredField('packingType')} onMouseLeave={() => setHoveredField(null)} style={fieldHoverStyle('packingType')}>
                          <InputText
                            placeholder="Enter Packing type"
                            name="packingType"
                            id="packingType"
                            className="w-full"
                            value={formik.values.packingType}
                            maxLength={200}
                            onChange={(e) => { const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');formik.setFieldValue('packingType', cleanedValue);}}
                            style={{ border: 'none', outline: 'none', width: '100%' }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid">
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="dateCode" style={{ fontWeight: 'bold' }}>Date Code & Batch Code</label>
                        <div onMouseEnter={() => setHoveredField('dateCode')} onMouseLeave={() => setHoveredField(null)} style={fieldHoverStyle('dateCode')}>
                          <InputText
                            placeholder="Enter Date & Batch code"
                            name="dateCode"
                            id="dateCode"
                            className="w-full"
                            value={formik.values.dateCode}
                            maxLength={200}
                            onChange={(e) => {
                              const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                              formik.setFieldValue('dateCode', cleanedValue);
                            }}
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="complaintType" style={{ fontWeight: 'bold' }}>Complaint Types
                          <span style={{ color: "red", fontSize: "24px" }}>*</span>
                        </label>
                        <div onMouseEnter={() => setHoveredField('complaintType')}onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('complaintType')}>
                          <Dropdown
                            placeholder="Select Complaint Types"
                            name="complaintType"
                            id="complaintType"
                            options={CompTyps}
                            optionLabel="complaintName"
                            optionValue="complaintTypeId"
                            value={formik.values.complaintType}
                            onChange={(e: DropdownChangeEvent) => handleCompTypeChange(e, formik.setFieldValue)}
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }} />
                        </div>
                        {formik.errors.complaintType && formik.touched.complaintType && (
                          <small className="p-error">{formik.errors.complaintType as string}</small>)}
                      </div>
                    </div>
                  </div>

                  <div className="field col-12 mb-3 px-3">
                    <label htmlFor="complaint" style={{ fontWeight: 'bold' }}>Description</label>
                    <div onMouseEnter={() => setHoveredField('complaint')} onMouseLeave={() => setHoveredField(null)} style={fieldHoverStyle('complaint')}>
                      <InputTextarea
                        placeholder="Enter Discription"
                        name="complaint"
                        id="complaint"
                        rows={5}
                        className="w-full"
                        value={formik.values.complaint}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                          formik.setFieldValue('complaint', cleanedValue);
                        }}
                        style={{border: 'none',outline: 'none',width: '100%',padding: '0.75rem',fontSize: '1rem'}}/>
                    </div>
                  </div>

                  <div className="grid">
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="image" style={{ fontWeight: 'bold' }}>Image</label>
                        <div onMouseEnter={() => setHoveredField('image')} onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('image')}>
                          <FileUpload
                            name="image"
                            id="image"
                            chooseLabel="Select Image"
                            accept="image/*"
                            customUpload
                            onUpload={handleImageUpload}
                            onClear={handleImageCancel}
                            auto
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                        {imageFile && (
                          <div className="p-mt-2">
                            <p>Selected Image: {imageFile.name}</p>
                            <button type="button" onClick={handleImageCancel} className="p-button p-button-danger p-button-sm">
                              Cancel
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="video" style={{ fontWeight: 'bold' }}>Video</label>
                        <div onMouseEnter={() => setHoveredField('video')} onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('video')}>
                          <FileUpload
                            name="video"
                            id="video"
                            chooseLabel="Select Video"
                            accept="video/*"
                            customUpload
                            onUpload={handleVideoUpload}
                            onClear={handleVideoCancel}
                            auto
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                        {videoFile && (
                          <div className="p-mt-2">
                            <p>Selected Video: {videoFile.name}</p>
                            <button type="button" onClick={handleVideoCancel} className="p-button p-button-danger p-button-sm">
                              Cancel
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="field col-12 mb-3 px-3">
                    <label htmlFor="remarks" style={{ fontWeight: 'bold' }}>Remarks</label>
                    <div onMouseEnter={() => setHoveredField('remarks')}onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('remarks')}>
                      <InputTextarea
                        placeholder="Enter Remarks"
                        name="remarks"
                        id="remarks"
                        rows={3}
                        className="w-full"
                        value={formik.values.remarks}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                          formik.setFieldValue('remarks', cleanedValue);
                        }}
                        style={{border: 'none',outline: 'none',width: '100%',padding: '0.75rem'}}/>
                    </div>
                  </div>

                  <div className="grid">
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="correctiveAction" style={{ fontWeight: 'bold' }}>
                          Corrective Action
                        </label>
                        <div onMouseEnter={() => setHoveredField('correctiveAction')}onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('correctiveAction')}>
                          <InputTextarea
                            placeholder="Enter Corrective Action"
                            name="correctiveAction"
                            id="correctiveAction"
                            rows={4}
                            className="w-full"
                            value={formik.values.correctiveAction}
                            onChange={(e) => {
                              const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                              formik.setFieldValue('correctiveAction', cleanedValue);
                            }}
                            style={{border: 'none',outline: 'none',width: '100%',padding: '0.75rem',fontSize: '1rem'}}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="preventiveAction" style={{ fontWeight: 'bold' }}>
                          Preventive Action
                        </label>
                        <div onMouseEnter={() => setHoveredField('preventiveAction')}onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('preventiveAction')}>
                          <InputTextarea
                            placeholder="Enter Preventive Action"
                            name="preventiveAction"
                            id="preventiveAction"
                            rows={4}
                            className="w-full"
                            value={formik.values.preventiveAction}
                            onChange={(e) => {
                              const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                              formik.setFieldValue('preventiveAction', cleanedValue);
                            }}
                            style={{border: 'none',outline: 'none',width: '100%',padding: '0.75rem',fontSize: '1rem'}}/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="field col-12 mb-3 px-3">
                    <label htmlFor="customerSupportAction" style={{ fontWeight: 'bold' }}>Customer Support Action</label>
                    <div onMouseEnter={() => setHoveredField('customerSupportAction')}onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('customerSupportAction')}>
                      <InputTextarea
                        placeholder="Enter Customer Support Action"
                        name="customerSupportAction"
                        id="customerSupportAction"
                        rows={4}
                        className="w-full"
                        value={formik.values.customerSupportAction}
                        onChange={(e) => {
                          const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                          formik.setFieldValue('customerSupportAction', cleanedValue);}}
                        style={{border: 'none',outline: 'none',width: '100%',padding: '0.75rem',fontSize: '1rem'}}/>
                    </div>
                  </div>

                  <div className="grid">
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="actionedBy" style={{ fontWeight: 'bold' }}>Actioned By<span style={{ color: "red", fontSize: "24px" }}>*</span></label>
                        <div
                          onMouseEnter={() => setHoveredField('actionedBy')}onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('actionedBy')}>
                          <Dropdown
                            placeholder="Select Actioned By"
                            name="actionedBy"
                            id="actionedBy"
                            options={adminUser}
                            optionLabel="detail"
                            optionValue="userID"
                            value={formik.values.actionedBy}
                            onChange={(e: DropdownChangeEvent) => handleAdminDropdownChange(e, formik.setFieldValue)}
                            onFilter={handleAdminDropdownFilter}
                            filter
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                        {formik.errors.actionedBy && formik.touched.actionedBy && (
                          <small className="p-error">{formik.errors.actionedBy as string}</small>)}
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="status" style={{ fontWeight: 'bold' }}>Status
                          <span style={{ color: "red", fontSize: "24px" }}>*</span>
                        </label>
                        <div onMouseEnter={() => setHoveredField('status')} onMouseLeave={() => setHoveredField(null)} style={fieldHoverStyle('status')}>
                          <Dropdown
                            placeholder="Select Status"
                            name="status"
                            id="status"
                            options={CompStatuss}
                            optionLabel="name"
                            optionValue="statusId"
                            value={formik.values.status}
                            onChange={(e: DropdownChangeEvent) => handleComStatusChange(e, formik.setFieldValue)}
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                        {formik.errors.status && formik.touched.status && (
                          <small className="p-error">{formik.errors.status as string}</small>)}
                      </div>
                    </div>
                  </div>

                  <div className="grid">
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="actionDate" style={{ fontWeight: 'bold' }}>Action Date</label>
                        <div onMouseEnter={() => setHoveredField('actionDate')} onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('actionDate')}>
                          <InputText
                            type="date"
                            name="actionDate"
                            id="actionDate"
                            value={formik.values.actionDate}
                            onChange={formik.handleChange}
                            onFocus={(e) => e.target.showPicker?.()}
                            onKeyDown={(e) => e.preventDefault()}
                            className={`w-full ${classNames({ 'p-invalid': formik.errors.actionDate })}`}
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="satisfactionLevel" style={{ fontWeight: 'bold' }}>Complaint Satisfaction</label>
                        <div onMouseEnter={() => setHoveredField('satisfactionLevel')}onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('satisfactionLevel')}>
                          <InputText
                            name="satisfactionLevel"
                            id="satisfactionLevel"
                            className="w-full"
                            value={formik.values.satisfactionLevel}
                            onChange={(e) => {
                              const cleanedValue = e.target.value.replace(/\s\s+/g, ' ');
                              formik.setFieldValue('satisfactionLevel', cleanedValue);}}
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid">
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="severity" style={{ fontWeight: 'bold' }}>Severity</label>
                        <div onMouseEnter={() => setHoveredField('severity')} onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('severity')}>
                          <Dropdown
                            placeholder="Select Severity"
                            name="severity"
                            id="severity"
                            options={severityItems}
                            optionLabel="name"
                            optionValue="name"
                            onChange={(e: DropdownChangeEvent) => handleSeverityChange(e, formik.setFieldValue)}
                            value={formik.values.severity}
                            className="w-full"
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="field mb-3 px-3">
                        <label htmlFor="copqInRs" style={{ fontWeight: 'bold' }}>COPQ in Rs</label>
                        <div onMouseEnter={() => setHoveredField('copqInRs')}onMouseLeave={() => setHoveredField(null)}style={fieldHoverStyle('copqInRs')}>
                          <InputNumber
                            placeholder="Enter COPQ in RS"
                            name="copqInRs"
                            id="copqInRs"
                            className="w-full"
                            value={formik.values.copqInRs !== null ? formik.values.copqInRs : null}
                            onValueChange={(e) => {
                              if (e.value !== null && e.value !== undefined && e.value >= 0) {
                                formik.setFieldValue("copqInRs", e.value);
                              }
                            }}
                            locale="en-IN"
                            maxFractionDigits={2}
                            style={{ border: 'none', outline: 'none', width: '100%' }}/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="field col-12 flex justify-content-end gap-3 mb-3 px-3">
                    <Button 
                      type="button" 
                      label="Reset" 
                      className="p-button-secondary" 
                      onClick={() => {
                        setShowForm(false);
                        setComplaintMode(null);
                        formik.resetForm();
                      }} 
                    />
              <Button 
                type="submit" 
                // label={`Save ${complaintMode === 'internal' ? 'Internal' : 'External'} Complaint`} 
                label ="Save Complaint"
                className="p-button-primary" 

              />
                  </div>
                </div>
              </form>
            
          </div>
        </div>
      </div>
      </div>
    </>
  );
};
export default InternalComplaint;